// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getPipCodeType} from '../../shared/repositories';

export const readPipCodeType = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getPipCodeType();

            dispatch({
                data,
                type: actions.READ_PIP_CODE_TYPE_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/pip/pip-code/action-creators/pip-code-type.js